import { createSlice } from '@reduxjs/toolkit';

const EMPTY_BUCKETS = {
    approved: [],
    under_review: [],
    unapproved: [],
    waitlist: [],
    rejected: [],
    deactivated: [],
};

const EMPTY_COUNTS = {
    approved: 0,
    under_review: 0,
    unapproved: 0,
    waitlist: 0,
    rejected: 0,
    deactivated: 0,
};

const talentSearchSlice = createSlice({
    name: 'talentSearch',
    initialState: {
        query: '',
        buckets: EMPTY_BUCKETS,
        counts: EMPTY_COUNTS,
        total: 0,
        isLoading: false,
        requestId: 0,
    },
    reducers: {
        searchTalent: (state, { payload }) => {
            state.query = payload.q;
            state.isLoading = true;
            state.requestId += 1;
        },
        talentSearchSucceeded: (state, { payload }) => {
            if (payload.requestId !== state.requestId) return;
            state.buckets = payload.buckets;
            state.counts = payload.counts;
            state.total = payload.total;
            state.isLoading = false;
        },
        talentSearchFailed: state => {
            state.isLoading = false;
        },
        clearTalentSearch: state => {
            state.query = '';
            state.buckets = EMPTY_BUCKETS;
            state.counts = EMPTY_COUNTS;
            state.total = 0;
            state.isLoading = false;
        },
    },
});

export const {
    searchTalent,
    talentSearchSucceeded,
    talentSearchFailed,
    clearTalentSearch,
} = talentSearchSlice.actions;

export const getTalentSearchState = state => state.talentSearch;

export default talentSearchSlice.reducer;
